/**
 * PasswordController.
 * A class to handle the password change functionality.
 */
class PasswordController {
  /**
   * createQuerySet.
   *
   * @param {number} passwordLength
   * @param {boolean} forceCaps
   * @param {boolean} forceNumber
   * @param {boolean} forceSymbol
   * @returns {RegExp}
   */
  static createQuerySet(passwordLength, forceCaps, forceNumber, forceSymbol) {
    // ^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{8,}$
    let querySet = '^'
    if (forceCaps) querySet += '(?=.*[A-Z])'
    if (forceNumber) querySet += '(?=.*\\d)'
    if (forceSymbol) querySet += '(?=.*[@$!%*?&"·$/()=¿+.:,;#·\\-\\_])'
    if (passwordLength) querySet += `[a-zA-Z\\d@$!%*?&+"·$/()=¿.:,;#·\\-\\_]{${passwordLength},}`
    querySet += '$'
    return new RegExp(querySet)
  }
}

export default PasswordController
